// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Контейнер для всей страницы */
.DocumentsPage_container__1jz6S {
  padding: 2rem;
  padding-top: 5rem;  /* Увеличиваем отступ сверху, чтобы контент не накладывался на меню */
  background-color: #f9f9f9;
  min-height: 100vh;
  position: relative;  /* Чтобы элемент не налезал на меню */
}

/* Заголовок */
.DocumentsPage_title__sEU4o {
  text-align: center;
  font-family: "Ysabeau SC", sans-serif;
  font-size: 2rem;
  color: #333;
  margin-bottom: 1rem;
}

/* Подзаголовок */
.DocumentsPage_subtitle__MwIW- {
  text-align: center;
  font-size: 1.2rem;
  color: #555;
  margin-bottom: 2rem;
}

/* Список документов */
.DocumentsPage_documentsList__8C4jV {
  display: flex;
  justify-content: center;
}

.DocumentsPage_list__MxxdL {
  list-style: none;
  padding: 0;
  max-width: 800px;
  width: 100%;
}

/* Каждый элемент списка */
.DocumentsPage_listItem__XzASQ {
  background-color: #fff;
  border: 1px solid #ddd;
  margin-bottom: 1rem;
  padding: 1rem;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center; /* Центрируем весь контент */
  transition: transform 0.3s ease;
}

.DocumentsPage_listItem__XzASQ:hover {
  transform: translateY(-5px);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

/* Ссылка на документ */
.DocumentsPage_link__0sZVQ {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #333;
  font-family: "Ysabeau SC", sans-serif;
  font-size: 1rem;
  justify-content: center;
  width: 100%;
}

.DocumentsPage_icon__7NMJ1 {
  font-size: 1.5rem;
  margin-right: 10px;
  color: #06478d;
  flex-shrink: 0; /* Иконка не сжимается */
  width: 2rem; /* Фиксированная ширина */
  height: 2rem; /* Фиксированная высота */
  display: flex; /* Центровка */
  align-items: center;
  justify-content: center;
}

/* Текст подписи */
.DocumentsPage_text__LJbpr {
  text-align: center; /* Центрируем текст */
  font-size: 1.1rem;
  width: 100%; /* Занимаем всю ширину внутри контейнера */
}

/* Адаптивность */
@media (max-width: 768px) {
  .DocumentsPage_container__1jz6S {
    padding: 1rem;
    padding-top: 6rem;  /* Увеличиваем отступ сверху для мобильных устройств */
  }

  .DocumentsPage_title__sEU4o {
    font-size: 1.5rem;
  }

  .DocumentsPage_subtitle__MwIW- {
    font-size: 1rem;
  }

  .DocumentsPage_listItem__XzASQ {
    padding: 0.8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DocumentsPage/DocumentsPage.module.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,aAAa;EACb,iBAAiB,GAAG,qEAAqE;EACzF,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB,GAAG,qCAAqC;AAC5D;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAE,4BAA4B;EACrD,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,qCAAqC;EACrC,eAAe;EACf,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,cAAc,EAAE,wBAAwB;EACxC,WAAW,EAAE,yBAAyB;EACtC,YAAY,EAAE,yBAAyB;EACvC,aAAa,EAAE,cAAc;EAC7B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB,EAAE,qBAAqB;EACzC,iBAAiB;EACjB,WAAW,EAAE,0CAA0C;AACzD;;AAEA,iBAAiB;AACjB;EACE;IACE,aAAa;IACb,iBAAiB,GAAG,sDAAsD;EAC5E;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Контейнер для всей страницы */\r\n.container {\r\n  padding: 2rem;\r\n  padding-top: 5rem;  /* Увеличиваем отступ сверху, чтобы контент не накладывался на меню */\r\n  background-color: #f9f9f9;\r\n  min-height: 100vh;\r\n  position: relative;  /* Чтобы элемент не налезал на меню */\r\n}\r\n\r\n/* Заголовок */\r\n.title {\r\n  text-align: center;\r\n  font-family: \"Ysabeau SC\", sans-serif;\r\n  font-size: 2rem;\r\n  color: #333;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n/* Подзаголовок */\r\n.subtitle {\r\n  text-align: center;\r\n  font-size: 1.2rem;\r\n  color: #555;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n/* Список документов */\r\n.documentsList {\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.list {\r\n  list-style: none;\r\n  padding: 0;\r\n  max-width: 800px;\r\n  width: 100%;\r\n}\r\n\r\n/* Каждый элемент списка */\r\n.listItem {\r\n  background-color: #fff;\r\n  border: 1px solid #ddd;\r\n  margin-bottom: 1rem;\r\n  padding: 1rem;\r\n  border-radius: 5px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center; /* Центрируем весь контент */\r\n  transition: transform 0.3s ease;\r\n}\r\n\r\n.listItem:hover {\r\n  transform: translateY(-5px);\r\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n/* Ссылка на документ */\r\n.link {\r\n  display: flex;\r\n  align-items: center;\r\n  text-decoration: none;\r\n  color: #333;\r\n  font-family: \"Ysabeau SC\", sans-serif;\r\n  font-size: 1rem;\r\n  justify-content: center;\r\n  width: 100%;\r\n}\r\n\r\n.icon {\r\n  font-size: 1.5rem;\r\n  margin-right: 10px;\r\n  color: #06478d;\r\n  flex-shrink: 0; /* Иконка не сжимается */\r\n  width: 2rem; /* Фиксированная ширина */\r\n  height: 2rem; /* Фиксированная высота */\r\n  display: flex; /* Центровка */\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n/* Текст подписи */\r\n.text {\r\n  text-align: center; /* Центрируем текст */\r\n  font-size: 1.1rem;\r\n  width: 100%; /* Занимаем всю ширину внутри контейнера */\r\n}\r\n\r\n/* Адаптивность */\r\n@media (max-width: 768px) {\r\n  .container {\r\n    padding: 1rem;\r\n    padding-top: 6rem;  /* Увеличиваем отступ сверху для мобильных устройств */\r\n  }\r\n\r\n  .title {\r\n    font-size: 1.5rem;\r\n  }\r\n\r\n  .subtitle {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .listItem {\r\n    padding: 0.8rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DocumentsPage_container__1jz6S`,
	"title": `DocumentsPage_title__sEU4o`,
	"subtitle": `DocumentsPage_subtitle__MwIW-`,
	"documentsList": `DocumentsPage_documentsList__8C4jV`,
	"list": `DocumentsPage_list__MxxdL`,
	"listItem": `DocumentsPage_listItem__XzASQ`,
	"link": `DocumentsPage_link__0sZVQ`,
	"icon": `DocumentsPage_icon__7NMJ1`,
	"text": `DocumentsPage_text__LJbpr`
};
export default ___CSS_LOADER_EXPORT___;
